export const getFormattedPaymentMethod = (type: string) => {
  switch (type) {
    case 'bank_account':
      return 'Bank';
    case 'credit':
      return 'Credit';
    case 'debit':
      return 'Debit';
    default:
      return type;
  }
};

export default {
  TYPE: {
    BANK_ACCOUNT: 'bank_account',
    CARD_CREDIT: 'credit',
    CARD_DEBIT: 'debit',
  },
  INPUT_TYPE: {
    BANK_PLAID: 'bank_plaid',
    BANK_MANUAL: 'bank_manual',
    STRIPE_ELEMENT: 'stripe_element',
  },
};
